// extracted by mini-css-extract-plugin
export default {"terms":"search-terms_terms__MCDSo","term":"search-terms_term__NtGEB"};